module.exports = __webpack_public_path__ + "75bd9246.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/media_thestraitstimes.png
// module id = 1695
// module chunks = 0